import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { BaseActionData } from './base-action-data';

/**
 * Représente les données d'une action 'Clos un workflow'.
 */
export class SwitchFolderAsUnreadActionData extends BaseActionData {
    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowActionTypes.SwitchFolderAsUnread);
    }

    /**
     * Retourne une copie d'une instance de SwitchFolderAsUnreadActionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: SwitchFolderAsUnreadActionData) {
        if (!!other) {
            const instance = new SwitchFolderAsUnreadActionData();
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
